import ImagesModel from "../../../Global/Models/Images/ImagesModel";
import RelatedEntityRelationship from "../../../Global/Models/Related/RelatedEntityRelationship";
import { GameStatusEnum } from "../../TopX/Enums/GameStatusEnum";
import StandingGameMetaModel from "./StandingGameMetaModel";

export default class StandingGameModel {
  public id: string = null;
  public title: string = null;
  public description: string | null = null;
  public rules: string | null = null;
  public customFields: Record<string, string> | null = null;
  public images: ImagesModel | null = null;
  public type: string = "STANDING";
  public status: GameStatusEnum = null;
  public points: number = null;
  public related: RelatedEntityRelationship[] = [];
  public predictionsCutoff: string = "";
  public meta: StandingGameMetaModel = new StandingGameMetaModel();
  public outcomeCount: number | null = null;
  public outcome: string[] = [];
  public createdAt: string = null;
  public updatedAt: string = null;
}
